import { GigaUserApi } from "@giga-user-fern/api";

export type AuthType = GigaUserApi.admin.AuthType;
export const AuthType = GigaUserApi.admin.AuthType;
